//funzione che imposta l'html nel drawer per l'aggiunta layer 
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import RestoreIcon from '@material-ui/icons/Restore';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import ChooseService from './ChooseService'
import ChooseFile from './ChooseFile'
import InserisciURL from './InsertURL'
import ReactFileUpload from './UploadFile'
import CheckBoxAddLayerFile from './CheckboxFIle'
import './AggiungiLayer.css'
import { Trans } from 'react-i18next';

const useStyles = makeStyles({
  root: {
    width: 'auto',
  }
  
});

function aggiungiURL(props) {
let typeService ='WMS'
  const getUrl = (url) =>{
    props.callback(url,typeService)
    
  }
  const setType = (type)=>{
    typeService = type
  }
    return(<div >
            <div className={"chooseServiceDiv"}>
                <p className={"chooseServiceTesto"}><Trans>Scegli il tipo di servizio</Trans></p>
                <div className={"chooseService"}>
                    <ChooseService callback={setType.bind(this)}/>
                    
                </div>
                
            </div>
           
            <InserisciURL callback={getUrl.bind(this)}/>
          

    </div>)
}

function aggiungiFile() {
  
    return(<div>
                  <div className={"chooseServiceDiv"}>
                <p className={"chooseServiceTesto"}><Trans>Scegli la tipologia di file</Trans></p>
                <div className={"chooseService"}>
                    <ChooseFile/>
                </div>
                
            </div>
            <div className={"specificationDiv"}><Trans>Errore ShapeFile</Trans></div>
              {/* <ReactFileUpload nome={<Trans>Carica</Trans>}/>  */}
            <CheckBoxAddLayerFile nome={<Trans>Carica</Trans>}/> 
    </div>)
}
export default function TabAddLayer(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(true);

  return (<div className={"serviceDiv"}>
    <BottomNavigation
      value={value}

      onChange={(event, newValue) => {
        props.callback("","")
        setValue(newValue);
      }}

      showLabels
      className={classes.root}
    >
      <BottomNavigationAction label={<Trans>Aggiungi da URL</Trans>} value={true} icon={<RestoreIcon />} />
      <BottomNavigationAction label={<Trans>Aggiungi da File</Trans>} value={false} icon={<AttachFileIcon />} />
    </BottomNavigation>
     {value ? aggiungiURL(props) : aggiungiFile()} 
    </div>
  );
}